import type React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PageOverlay: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => <Overlay {...props} />;

export default PageOverlay;
